export default __webpack_public_path__ + "static/media/arches.79af2410.png";